import { takeEvery, put } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import { getOverviewOrderData, getOverviewOrderDataSuccess, getNewOrderData, getNewOrderDataSuccess, getPreparingOrderData, getPreparingOrderDataSuccess, getDispatchedOrderData, getDispatchedOrderDataSuccess, getOpenOrderData, getOpenOrderDataSuccess, getDeliveredOrderData, getDeliveredOrderDataSuccess, getCancelledOrderDataSuccess, getCancelledOrderData, getSearchOrders, getSearchOrdersSuccess, updateOrderStatus, fetchOrderData, updateSoldOutItem, aggregatorDataUpdate, fetchHoldOrder, getProcessedOrderData, getProcessedOrderDataSuccess, getCallBtnApi, saveMyorder, saveMyorderSuccess, voidOrder, unvoidOrder, uncancelledOrder, swiggyCallBtnApi, fetchFeebackLink, generateAggregatorBill, updateFulfillmentStatus, assignRider, cancelRider, fetchOrderDataSuccess, fetchApprovalStatus, checkDeliveryPartner, getCustomerMaskedNumber, cancelOnlineOrder, getTotalSaleReturnAmount, getItemImageForOnlineOrder, getChatSupportUrl, getChatSupportUrlSuccess, saveZomatoChatSupportList, checkForZomatoChatSupport, getPreparedOrderDataSuccess, getPreparedOrderData } from "../../slices/MyOrderSlice";
import { saveSaleData } from "../../slices/SaleSlice";
import { updateDiscountApprovalState } from "../../../helpers/updateDiscountApprovalState";
import { updateNcApprovalState } from "../../../helpers/updateNcApprovalState";
import { updateAdhocTables } from "../../../helpers/adhocTableHelpers";
import { updateSyncedSale } from "../../../helpers/OfflineHelper";
import { saveBackOrderShowModal } from "../../slices/CustomerSlice";
import { notifyError, notifySuccess } from "../../../effects-bridge";
import { getErrorMessage } from "../../../utils/posErrors";
import { INSUFFICIENT_STOCK } from "../../../data/constants";
import moment from "moment";
import {
  getAggregatorDataUpdate, getHoldOrders, getCallBtn, swiggyCallBtn, getFeedBackLink, handleAssignRider,
  // The nine order-list fetchers are one worker behind `watchListFetches` (shared.ts).
  watchListFetches, watchSearch, generateAggregatorBillSaga, getApprovalStatus, getCustomerNumber, soldOutItem,
  cancelSwiggyOrders, getsaleReturnAmount, getChatSupportUrls, checkForZomatoChatSupportFn,
  getItemImage,
} from "./shared";

/**
 * WEB half of `redux-store/saga/myOrder`. `shared.ts` owns the six identical workers and carries
 * the full divergence map — read it before changing anything here.
 *
 * This side now holds only its half of the nineteen divergent workers. The nine that used to be
 * web-only (prepared-orders, aggregator bill, approval status, masked customer number, Swiggy
 * cancellation, sale-return amount, the two chat-support workers and item images) moved to
 * `shared.ts` in the web-adoption pass — they are pure `api.request` + `put`, so mobile runs
 * them now too.
 *
 * ⚠️ Every core import names the VARIANT, not the folder (hazard 6/16).
 *
 * ⚠️ The order-bucket fetchers pass this platform's own axios loader flag; see `shared.ts` for
 * why that one line keeps eight otherwise-identical workers out of the shared file.
 */

export * from "./shared";









function* updateFulfillmentStatement(action: any): Generator<any, void, any> {
  let payload = action.payload;
  let { callback, ...otherData } = payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: `sale/${payload.saleId}/fulfillment/update`,
      data: payload.payloadToSend,
      hideLoader: false
    } as any);
    if (response && !response?.code) {
      updateSyncedSale(response);
    }
    if (response) {
      payload.callback(response);
    }  
  } catch (error: any) {
    console.log("error", error);
  }
}

function* updateFulfillmentStatusSaga(action: any): Generator<any, void, any> {
  let { callback, ...otherData } = action.payload;  
  try {
    const response = yield api.request({
      method: "POST",
      url: `sale/fulfillment/update`,
      data: action?.payload?.dataToPost,
      hideLoader: false
    } as any);
    if (response) {
      action?.payload?.callback(response);
    }
  } catch (error: any) {
    console.log("error", error);
  }
}

function* fetchMyOrderData(action: any): Generator<any, void, any> {
  try {
    const response = yield api.request({
      method: "GET",
      // Was this exact string, hardcoded in BOTH variants while the endpoint map carried a
      // dead, half-written `getOrderData`. One definition now; the URL is unchanged.
      url: ENDPOINT.MYORDER.getOrderData(action.payload.saleId),
    });
    if(!action.payload.doNotSaveSale)
    {
      yield put(saveSaleData(response))
    }
    if (response) action.payload.callback(response);
    updateDiscountApprovalState(response, true);
    updateNcApprovalState(response, true);
    yield put(fetchOrderDataSuccess(response));
  } catch (error: any) {
    console.log(error);
  }
}


function* saveMyOrderSale(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.POS.saveSaleData(),
      data: payload.dataToSend,
      hideLoader: false
    } as any);
    if (response) {
      if(response?.errors?.includes(INSUFFICIENT_STOCK))
      {
        yield put(saveBackOrderShowModal(true))
      }
      if (!response?.code && !response.operation) {
        updateSyncedSale(response);
      }
      updateAdhocTables(response);
      payload.callback(response);
      yield put((saveMyorderSuccess as any)());
    }
  } catch (error: any) {
    console.log(error);
  }
}

function* setVoidOrder(action: any): Generator<any, void, any> {
  let payload = {
    ...(action?.payload?.reason || {}),
    ...(action?.payload?.returnData || {}),
  };
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.MYORDER.voidSale(action?.payload?.id),
      data: payload || {},
    });
    if (response && !response?.code) {
      updateSyncedSale(response);
    }
    if (response) {
      action?.payload?.callback(response);
    }
  } catch (error: any) {
    console.log(error);
  }
}

function* setUnvoidOrder(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.MYORDER.unvoidSale(payload?.id),
      data: payload?.dataToSend || {},
    });
    if (response && !response?.code) {
      updateSyncedSale(response);
    }
    if (response) {
      payload.callback();
    }
  } catch (error: any) {
    console.log(error);
  }
}

function* setUncancelledOrder(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.MYORDER.uncancelSale(payload?.id),
      data: payload?.dataToSend || {},
    });
    if (response && !response?.code) {
      updateSyncedSale(response);
    }
    if (response) {
      payload.callback();
    }
  } catch (error: any) {
    console.log(error);
  }
}

function* getDeliveryPartnerDetails(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.MYORDER.checkDeliveryPartner(payload.data),
    });
    if (response && payload.callback) {
      payload.callback(response);
    } else {
      payload.callback({
        code: "Feedback already captured for this sale",
      });
    }
  } catch (error: any) {
    console.log(error);
  }
}

function* handleCancelRider(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.MYORDER.cancelRiderApi(payload.mid),
      data: JSON.stringify(payload.data),
    });
    if (response && payload.callback) {
      payload.callback(response);
    } else {
      payload.callback({
        code: "Feedback already captured for this sale",
      });
    }
  } catch (error: any) {
    console.log(error);
    payload.callback({ code: error });
  }
}

export default function* root() {
  yield* watchListFetches(); // the nine order lists, takeLatest per list — see shared.ts
  yield* watchSearch(); // the search worker, takeLatest — converged on web's body (D12), see shared.ts
  yield takeEvery(updateOrderStatus.type, updateFulfillmentStatement);
  yield takeEvery(fetchOrderData.type, fetchMyOrderData);
  yield takeEvery(updateSoldOutItem.type, soldOutItem);
  yield takeEvery(aggregatorDataUpdate.type, getAggregatorDataUpdate);
  yield takeEvery(fetchHoldOrder.type, getHoldOrders);
  yield takeEvery(getCallBtnApi.type, getCallBtn);
  yield takeEvery(saveMyorder.type, saveMyOrderSale);
  yield takeEvery(voidOrder.type, setVoidOrder);
  yield takeEvery(unvoidOrder.type, setUnvoidOrder);
  yield takeEvery(uncancelledOrder.type, setUncancelledOrder);
  yield takeEvery(swiggyCallBtnApi.type, swiggyCallBtn);
  yield takeEvery(fetchFeebackLink.type, getFeedBackLink);
  yield takeEvery(generateAggregatorBill.type, generateAggregatorBillSaga);
  yield takeEvery(updateFulfillmentStatus.type, updateFulfillmentStatusSaga);
  yield takeEvery(checkDeliveryPartner.type, getDeliveryPartnerDetails);
  yield takeEvery(assignRider.type, handleAssignRider);
  yield takeEvery(cancelRider.type, handleCancelRider);
  yield takeEvery(fetchApprovalStatus.type, getApprovalStatus);
  yield takeEvery(getCustomerMaskedNumber.type, getCustomerNumber);
  yield takeEvery(cancelOnlineOrder.type, cancelSwiggyOrders);
  yield takeEvery(getTotalSaleReturnAmount.type, getsaleReturnAmount);
  yield takeEvery(getItemImageForOnlineOrder.type, getItemImage);
  yield takeEvery(getChatSupportUrl.type, getChatSupportUrls);
  yield takeEvery(checkForZomatoChatSupport.type, checkForZomatoChatSupportFn);
}
